import { useContext, useMemo } from "react";
import RosterContext from "../../contexts/RosterContext";

/**
 * Custom hook to check if a player is already on the provisional or final roster
 * @param {number|string} profileId - The profile ID to check
 * @returns {boolean} - True if player is on provisional or final roster, false otherwise
 */
const useIsPlayerOnRoster = profileId => {
  const rosterContext = useContext(RosterContext);
  const { players } = rosterContext.state.provisional;

  const isOnRoster = useMemo(() => {
    return players.some(player => player.profileId == profileId);
  }, [players, profileId]);

  return isOnRoster;
};

export default useIsPlayerOnRoster;
